import Button from "../../audi-ui-components/Button";
import {
  requestTypes,
} from "./CVOConstants";

const SubmittedBanner = ({ requestType }) => {
  return (
    <div className="aui-color-black aui-color-text-light py-5">
      {requestType === requestTypes.PERSONAL_DETAILS_CHANGED && <div className="audi-forms__page py-medium-5">
        <p className="aui-headline-3 mb-3">Thank you, your updated details have been submitted.</p>
        <p className="mb-5">We'll contact you within 5 business days to confirm these changes.</p>
        <div className="cvo-thankyou-ctas">
          <Button variant="primary" theme="light" href="https://www.audi.com.au/en/owners/service/">
            Discover owner benefits
          </Button>
        </div>
      </div>}
      {requestType === requestTypes.NEW_OWNER && <div className="audi-forms__page py-medium-5">
        <p className="aui-headline-3 mb-3">Congratulations on your new Audi</p>
        <p className="mb-5">We'll contact you within 5 business days to confirm we've received all your details.</p>
        <div className="cvo-thankyou-ctas">
          <Button variant="primary" theme="light" href="https://www.audi.com.au/en/owners/service/">
            Discover owner benefits
          </Button>
        </div>
      </div>}
      {requestType === requestTypes.NO_LONGER_OWN && <div className="audi-forms__page py-medium-5">
        <p className="aui-headline-3 mb-3">Thank you, your updated details have been submitted.</p>
        <p className="mb-5">We'll contact you within 5 business days to confirm these changes.</p>
        <div className="cvo-thankyou-ctas">
          <Button variant="primary" theme="light" href="https://www.audi.com.au/en/models/">
            Discover new models
          </Button>
        </div>
      </div>}
      {requestType === requestTypes.WRITTEN_OFF && <div className="audi-forms__page py-medium-5">
        <p className="aui-headline-3 mb-3">Thank you, your updated details have been submitted.</p>
        <p className="mb-5">We'll contact you within 5 business days to confirm these changes.</p>
        <div className="cvo-thankyou-ctas">
          <Button variant="primary" theme="light" href="https://www.audi.com.au/en/audi-new-car-search/">
            Shop new vehicles
          </Button>
          <Button variant="secondary" theme="light" href="https://www.audi.com.au/en/audi-used-car-search/">
            Shop pre-owned vehicles
          </Button>
        </div>
      </div>}
    </div>
  );
};

export default SubmittedBanner;
